import { CallFileType } from "@prisma/client";
import { CallFile } from "@/app/types/call/CallFile";
import { PlaceholderRow } from "@/app/types/common/PlaceholderRow";
import { UFile } from "@/app/utils/UFile";
import { CALL_STATUS_MAP } from "../../CallAnalysis.logic";

export { CALL_STATUS_MAP };

// Blurred placeholder rows tuned to the real columns:
// Name (icon + line) · Type · Member · Status (badges) · Run / Menu (icon buttons).
const CALLS_PLACEHOLDER_NAME_WIDTHS = ["64%", "52%", "70%", "48%", "60%", "56%", "68%", "50%"];

export const CALLS_PLACEHOLDER_ROWS: PlaceholderRow[] = CALLS_PLACEHOLDER_NAME_WIDTHS.map(
  (nameWidth) => ({
    withIcon: true,
    cells: [
      { width: nameWidth },
      { width: "110px", pill: true },
      { width: "120px", pill: true },
      { width: "90px", pill: true },
      { width: "32px", circle: true },
      { width: "30px", circle: true },
    ],
  }),
);

export function resolveCallFileType(callFile: CallFile): CallFileType {
  if (callFile.file) {
    return UFile.getCallFileType(callFile.file);
  }

  if (callFile.savedCall) {
    return callFile.savedCall.fileType;
  }

  throw new Error("Unable to resolve call file type");
}

export function getCallDisplayName(callFile: CallFile): string {
  return callFile.label || callFile.savedCall?.name || callFile.file?.name || "";
}

export function getCallFileSize(callFile: CallFile): number {
  return callFile.file?.size ?? callFile.savedCall?.fileSize ?? 0;
}

export const ITEMS_PER_PAGE = 10;

export enum CallColumn {
  NAME = "name",
  TYPE = "type",
  MEMBER = "member",
  STATUS = "status",
  RUN = "run",
  MENU = "menu",
}
